import { SceneService } from '$src/js/modules/hero/services/SceneService';
import { ModelService } from '$src/js/modules/hero/services/ModelService';
import { TextureService } from '$src/js/modules/hero/services/TextureService';
import { GuiService } from '$src/js/modules/hero/services/GuiService';
import { LoaderService } from '$src/js/modules/hero/services/LoaderService';
import { IntroService } from '$src/js/modules/hero/services/IntroService';

export default class HeroModule {
  private static instance: HeroModule | null = null;
  private _scene: SceneService | null = null;
  private _model: ModelService | null = null;
  private _texture: TextureService | null = null;
  private _gui: GuiService | null = null;
  private _loader: LoaderService | null = null;
  private _intro: IntroService | null = null;

  static getInstance(): HeroModule {
    HeroModule.instance ??= new HeroModule();
    return HeroModule.instance;
  }

  get scene(): SceneService {
    this._scene ??= new SceneService();
    return this._scene;
  }

  get model(): ModelService {
    this._model ??= new ModelService();
    return this._model;
  }

  get texture(): TextureService {
    this._texture ??= new TextureService();
    return this._texture;
  }

  get gui(): GuiService {
    this._gui ??= new GuiService();
    return this._gui;
  }

  get loader(): LoaderService {
    this._loader ??= new LoaderService();
    return this._loader;
  }

  get intro(): IntroService {
    this._intro ??= new IntroService();
    return this._intro;
  }

  readonly dispose = (): void => {
    this._gui?.dispose();
    this._model?.dispose();
    this._scene?.dispose();
    this._gui = null;
    this._model = null;
    this._texture = null;
    this._scene = null;
    this._loader = null;
    this._intro = null;
  };
}
